import { useMutation } from "@tanstack/react-query";
import {
  getProminentB64,
  type InputWord,
  type ProcessingError,
} from "./api-client";
import { useUserPrefs } from "./stores/user-prefs";

export type { ProcessingError };

export class ApiProcessingError extends Error {
  constructor(
    public code: ProcessingError,
    public timestamp: number,
  ) {
    super(code);
    this.name = "ApiProcessingError";
  }
}

export const useScoreRecording = () => {
  const prefs = useUserPrefs();

  return useMutation({
    mutationFn: async (request: {
      recording_b64: string;
      word: Omit<InputWord, "syllables"> & { syllables: readonly string[] };
    }) => {
      const { data: result, response } = await getProminentB64({
        body: {
          recording_b64: request.recording_b64,
          word: { ...request.word, syllables: [...request.word.syllables] },
          username: prefs?.username,
          audio_authorization: prefs?.audioAuthorization,
        },
      });

      if (!result) {
        throw new Error(`API error: ${response?.status ?? "no response"}`);
      }

      if (!result.success) {
        console.error(
          "API error:",
          result.error,
          "timestamp:",
          result.timestamp,
        );
        throw new ApiProcessingError(result.error, result.timestamp);
      }

      return result.data;
    },
  });
};
